import React from 'react'
import { Link } from "react-router-dom";


const GeneralSurgery = () => {
  return (
    <>
      <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
        <div className="container">
          <div className="dz-bnr-inr-entry d-table-cell">
            <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>जनरल सर्जरी</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <ul className="">
                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                <li className="breadcrumb-item">जनरल सर्जरी</li>
              </ul>
            </nav>
            <div className="dz-btn">
              <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                <span className="left-icon">
                  <i className="feather icon-phone-call" />
                </span>
                +91 9165155945
              </a>
            </div>
          </div>
        </div>
        <span className="text-vertical">24/7 आपातकालीन सेवा</span>
        <ul className="dz-social">
          <li>
            <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
              <i className="fa-brands fa-facebook-f" />
            </Link>
          </li>
          <li>
            <a to="https://www.instagram.com" target="_blank">
              <i className="fa-brands fa-instagram" />
            </a>
          </li>

          <li>
            <a to="https://twitter.com" target="_blank">
              <i className="fa-brands fa-x-twitter" />
            </a>
          </li>
          <li>
            <a to="https://www.youtube.com" target="_blank">
              <i className="fa-brands fa-youtube" />
            </a>
          </li>
        </ul>
      </div>

      <section className="content-inner" style={{ marginTop: "-10px" }}>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/General Surgery_01.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/General Surgery_02.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/General Surgery_03.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/General Surgery_04.webp" alt="/" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="content-inner service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 single-inner order-lg-1">
              <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                <img src="./assets/img/General Surgery.webp" alt className="object-fit-cover" />
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                <h2>जनरल सर्जरी</h2>
                <p>जनरल सर्जरी की मुख्य जानकारी में एनाटॉमी, फिजियोलॉजी, मेटाबॉलिज्म, इम्यूनोलॉजी, न्यूट्रिशन, पैथोलॉजी, घाव भरना, शॉक और रिससिटेशन, इंटेंसिव केयर, और नियोप्लासिया शामिल हैं, जो सभी सर्जिकल स्पेशलिटीज़ में शेयर किए जाते हैं।</p>
                <p>हमारे यहाँ जनरल सर्जरी के अंतर्गत कई प्रकार की बीमारियों का आधुनिक और सुरक्षित उपचार किया जाता है। हमारी टीम नवीनतम तकनीकों जैसे Laser Surgery, Laparoscopic (Durbeen) Surgery और Open Surgery का उपयोग करती है, ताकि मरीज को कम दर्द, जल्दी रिकवरी और बेहतर परिणाम मिल सके।</p>
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅  लीवर रोग एवं पैंक्रियास</li>
                  <li>  ✅  घाव का ठीक ना होना</li>
                  <li>  ✅  पैरों की नशे सूजना</li>
                  <li>  ✅  शरीर में कहीं गठान</li>
                  <li>  ✅ लीवर रोग पेंक्रियाज </li>
                  <li>  ✅  मूत्र एवं किडनी रोग</li>
                  <li>  ✅ आँत एवं पेट का कैंसर </li>
                  <li>  ✅  आँचल की गठान एवं अन्य रोग</li>
                  <li>  ✅ कब्ज </li>
                  <li>  ✅  आँतों के रोग</li>
                  <li>  ✅ पथरी </li>
                  <li>  ✅  हार्निया</li>
                  <li>  ✅ बवासीर (पाइल्स) </li>
                  <li>  ✅  शरीर के अन्य घाव एवं सूजन</li>
                  <li>  ✅  Laser Surgery – कम दर्द, बिना टांके या कम टांके, जल्दी रिकवरी</li>
                  <li>  ✅  Laparoscopic (Durbeen) Surgery – छोटे छेद से ऑपरेशन, कम निशान</li>
                  <li>  ✅  Open Surgery – जहाँ जरूरत हो, पारंपरिक और सुरक्षित तरीका</li>
                  <li>  ✅  अनुभवी सर्जन और आधुनिक उपकरण</li>
                  <li>  ✅  मरीज की सुरक्षा और आराम हमारी प्राथमिकता</li>
                  <li>  ✅  आंतो में सूजन एवं रुकावट, दुरबीन द्वारा पित्त की थैली का ऑपरेशन अपेंडिक्स का ऑपरेशन, फिस्टुला का ऑपरेशन, गाँठ व मवाद का इलाज व पेट संबंधी अन्य किसी भी रोग से ग्रस्त है</li>

                </ul>
              </div>
            </div>
            <div className="col-lg-4 m-b30">
              <aside className="side-bar sticky-top left">
                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                  <div className="widget-title">
                    <h4 className="title">सभी सेवाएँ</h4>
                  </div>
                  <ul>
                    <li className="active"><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                    <li><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                    <li><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                    <li ><Link to="/urology">यूरोलॉजी</Link></li>
                    <li ><Link to="/dermatology">डर्मेटोलॉजी</Link></li>
                    <li ><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                    <li><Link to="/ent">कान, नाक और गले</Link></li>
                    <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                    <li><Link to="/dental">डेंटल</Link></li>
                    <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                    <li><Link to="/gynaecology">ऑब्सटेट्रिक्स और गायनेकोलॉजी</Link></li>
                    <li><Link to="/paediatrics">पीडियाट्रिक्स</Link></li>
                  </ul>
                </div>
                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                  <div className="widget-content">
                    <img src="./assets/images/question.png" width={80} alt />
                    <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                    <div className="phone-number">
                      <a href="tel:+919165155945">+91 9165155945</a>
                    </div>
                    <div className="email">
                      <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                        @gmail.com</a>
                    </div>
                    <div className="link-btn">
                      <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                        Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default GeneralSurgery